var keyboardAccessibility = require('./keyboardAccessibility');
var gtm = require('googletagmanager/tagManager');
const { applyUrlParameter, isRelativeUrl } = require('../utilities');
var constants = require('./constants');
var closeButtonHideTimeoutId;

/**
 * updateSubmenuTabbability - updates tabindex on links inside dropdown menus
 * so that only links within open containers are tabbable.
 * All others get tabindex="-1".
 */
function updateSubmenuTabbability() {
    var $openTopLevelMenus;
    var $openNestedMenus;
    var $activeCloseButtons = $();
    var $activeCloseContainers = $();
    var scheduleHide = function (callback) {
        if (closeButtonHideTimeoutId) {
            window.clearTimeout(closeButtonHideTimeoutId);
        }

        closeButtonHideTimeoutId = window.setTimeout(function () {
            closeButtonHideTimeoutId = null;
            callback();
        }, 400);
    };

    // Remove stale expanded classes from descendants when parent branches are collapsed.
    $('.nav-item.dropdown:not(.show) .dropdown-item.dropdown.show').removeClass('show');
    $('.nav-item.dropdown:not(.show) .submenu-outer.dropdown-menu.show').removeClass('show');
    $('.dropdown-item.dropdown:not(.show) .submenu-outer.dropdown-menu.show').removeClass('show');

    $openTopLevelMenus = $('.nav-item.dropdown.show > .submenu-outer.menu-level-1.show');
    $openNestedMenus = $('.nav-item.dropdown.show .dropdown-item.dropdown.show > .submenu-outer.dropdown-menu.show');

    // Keep aria-hidden or hidden attributes synchronized only with currently open menu branches.
    $('.submenu-outer.dropdown-menu').attr('hidden', 'true');
    $openTopLevelMenus.removeAttr('hidden');
    $openNestedMenus.removeAttr('hidden');

    // Show only one desktop close button per open branch.
    // Level-1 stays active until a nested level-2 submenu opens.
    $openTopLevelMenus.each(function () {
        var $topLevelMenu = $(this);
        var $topLevelCloseContainer = $topLevelMenu.children('.close-menu-desktop');
        var $openNestedMenu = $topLevelMenu
            .find('.dropdown-item.dropdown.show > .submenu-outer.dropdown-menu.show')
            .first();

        if ($openNestedMenu.length) {
            $activeCloseContainers = $activeCloseContainers.add(
                $openNestedMenu.children('.close-menu-desktop')
            );
            $activeCloseButtons = $activeCloseButtons.add(
                $openNestedMenu.children('.close-menu-desktop').find('.close-button')
            );
        } else {
            $activeCloseContainers = $activeCloseContainers.add($topLevelCloseContainer);
            $activeCloseButtons = $activeCloseButtons.add(
                $topLevelCloseContainer.find('.close-button')
            );
        }
    });

    $activeCloseContainers.removeClass('d-none');
    $activeCloseButtons.removeClass('d-none');
    scheduleHide(function () {
        $('.submenu-outer .close-menu-desktop').not($activeCloseContainers).addClass('d-none');
        $('.submenu-outer .close-menu-desktop .close-button').not($activeCloseButtons).addClass('d-none');
    });

    // Hidden descendants should never be tabbable.
    $('.submenu-outer a, .submenu-outer button').attr('tabindex', '-1');

    // Only links and buttons visible within the currently open top-level branch are tabbable.
    $openTopLevelMenus.find('a, button')
        .filter(':visible')
        .removeAttr('tabindex');
}

/**
 * Normalize text used for accessible-name composition.
 *
 * @param {string} value - Raw text value.
 * @returns {string} Normalized text.
 */
function normalizeMenuLabelText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
}

/**
 * Announce menu expanded/collapsed state for screen readers.
 *
 * @param {JQuery<HTMLElement>} $element - Dropdown control element.
 * @param {boolean} isExpanded - Whether the control is expanded.
 */
function announceMenuState($element, isExpanded) {
    var $liveRegion;
    var controlLabel;
    var stateText;
    var announcement;

    if (!$element || !$element.length) {
        return;
    }

    $liveRegion = $('.js-navigation').find('.js-menu-aria-status').first();
    if (!$liveRegion.length) {
        return;
    }

    controlLabel = normalizeMenuLabelText($element.attr('aria-label')
        || $element.clone().children('.icon-holder').remove().end().text());
    stateText = isExpanded
        ? ($liveRegion.data('expandedText') || 'expanded')
        : ($liveRegion.data('collapsedText') || 'collapsed');
    announcement = controlLabel ? controlLabel + ' ' + stateText : stateText;

    $liveRegion.text(' ');
    window.setTimeout(function () {
        $liveRegion.text(announcement);
    }, 30);
}

/**
 * Updates aria-expanded state only for dropdown-link submenu controls.
 *
 * @param {JQuery<HTMLElement>} $element - Dropdown control element.
 * @param {boolean} isExpanded - Whether the control is expanded.
 */
function setDropdownLinkExpandedState($element, isExpanded) {
    var describedBy;

    if (!$element || !$element.length) {
        return;
    }

    if ($element.is('button, a') || typeof $element.attr('aria-expanded') !== 'undefined') {
        $element.attr('aria-expanded', isExpanded ? 'true' : 'false');

        describedBy = $element.attr('aria-describedby');
        if (describedBy) {
            describedBy = describedBy
                .replace(/-collapsed$/, '')
                .replace(/-expanded$/, '');
            $element.attr('aria-describedby', describedBy + (isExpanded ? '-expanded' : '-collapsed'));
        }

        announceMenuState($element, isExpanded);
    }
}

/**
 * Build a contextual label for menu promo links.
 *
 * @param {string} linkText - Visible CTA text.
 * @param {string} contextText - Nearby descriptive text.
 * @returns {string} Contextual label.
 */
function buildContextualMenuLabel(linkText, contextText) {
    var normalizedLinkText = normalizeMenuLabelText(linkText);
    var normalizedContextText = normalizeMenuLabelText(contextText);

    if (!normalizedLinkText) {
        return '';
    }

    if (!normalizedContextText) {
        return normalizedLinkText;
    }

    if (normalizedContextText.toLowerCase().indexOf(normalizedLinkText.toLowerCase()) !== -1) {
        return normalizedContextText;
    }

    return normalizedLinkText + ' - ' + normalizedContextText;
}

/**
 * Add contextual aria-label values to floating promo links when missing.
 *
 * @param {JQuery<HTMLElement>} $scope - DOM scope to enhance.
 */
function applyContextualLabelsToFloatingLinks($scope) {
    if (!$scope || !$scope.length) {
        return;
    }

    $scope.find('.floating-link a').each(function () {
        var $link = $(this);

        if ($link.attr('aria-label')) {
            return;
        }

        var linkText = normalizeMenuLabelText($link.text());
        if (!linkText) {
            return;
        }

        var $promoImage = $link.closest('.promotional-image');
        var imageAlt = normalizeMenuLabelText($promoImage.find('img[alt]').first().attr('alt'));
        var imageTitle = normalizeMenuLabelText($promoImage.find('img[title]').first().attr('title'));
        var headingText = normalizeMenuLabelText($promoImage.find('h1, h2, h3, h4, h5, h6').first().text());
        var contextText = imageAlt || imageTitle || headingText;
        var contextualLabel = buildContextualMenuLabel(linkText, contextText);

        if (contextualLabel) {
            $link.attr('aria-label', contextualLabel);
        }
    });
}

/**
 * Focus the first visible focusable element in an opened submenu on the next frame.
 *
 * @param {JQuery<HTMLElement>} $menuItem - Dropdown list item that owns the submenu.
 */
function focusFirstSubmenuItem($menuItem) {
    var scheduleFocus = window.requestAnimationFrame || function (callback) {
        window.setTimeout(callback, 0);
    };

    if (!$menuItem || !$menuItem.length) {
        return;
    }

    scheduleFocus(function () {
        var $submenu = $menuItem.children('.dropdown-menu.show').first();
        var $firstFocusable;

        if (!$submenu.length) {
            return;
        }

        updateSubmenuTabbability();

        $firstFocusable = $submenu
            .find('> .submenu-container.left-content > .dropdown-container > li > a, > .submenu-container.left-content > .dropdown-container > li > button')
            .filter(':visible')
            .not('[tabindex="-1"]')
            .first();

        if ($firstFocusable.length) {
            $firstFocusable.focus();
        }
    });
}

/**
 * Get currently focusable controls within the active open submenu.
 *
 * @param {HTMLElement} element - Current focused element.
 * @returns {JQuery<HTMLElement>} Focusable controls in DOM order.
 */
function getActiveSubmenuFocusableElements(element) {
    var $currentElement = $(element);
    var $activeSubmenu = $currentElement.closest('.submenu-outer.dropdown-menu.show');

    if (!$activeSubmenu.length) {
        return $();
    }

    return $activeSubmenu.find('a[href], button:not([disabled]), [tabindex="0"]')
        .filter(':visible')
        .filter(function () {
            return $(this).attr('tabindex') !== '-1';
        });
}

/**
 * Move focus within the active submenu and wrap at either end.
 *
 * @param {HTMLElement} element - Current focused element.
 * @param {number} step - Direction to move, 1 or -1.
 * @returns {boolean} True when focus moved inside the submenu.
 */
function moveFocusWithinActiveSubmenu(element, step) {
    var $focusableElements = getActiveSubmenuFocusableElements(element);
    var currentIndex = $focusableElements.index(element);
    var nextIndex;

    if (!$focusableElements.length || currentIndex === -1) {
        return false;
    }

    nextIndex = currentIndex + step;

    if (nextIndex < 0) {
        nextIndex = $focusableElements.length - 1;
    } else if (nextIndex >= $focusableElements.length) {
        nextIndex = 0;
    }

    $focusableElements.eq(nextIndex).focus();

    return true;
}

/**
 * Collapse any expanded menu triggers inside the provided scope.
 *
 * @param {JQuery<HTMLElement>|string} scope - Container or selector to search within.
 */
function collapseExpandedMenuTriggers(scope) {
    $(scope).find('[aria-expanded="true"].nav-link, [aria-expanded="true"].dropdown-link').each(function () {
        setDropdownLinkExpandedState($(this), false);
    });
}

var clearSelection = function (element) {
    var $closingDropdown = $(element).closest('.dropdown.show');
    $closingDropdown.children('.dropdown-menu').attr('hidden', 'true');
    setDropdownLinkExpandedState($closingDropdown.children().first(), false);
    $closingDropdown.removeClass('show');
    $(element).closest('.dropdown').find('.dropdown-menu.show').removeClass('show');
    $('div.menu-group > ul.nav.navbar-nav > li.nav-item > a').attr('aria-hidden', 'false');
    $('.menu-level-1 .submenu-container.right-content.content-level-1').removeClass('d-none');
    $(element).parent().closest('.dropdown-container').children('.top-category')
        .detach();
    $(element).parent().closest('.dropdown-container').children('.nav-menu')
        .detach();
    // Reset submenu tabbability after closing using shared helper to avoid drift
    if (typeof updateSubmenuTabbability === 'function') {
        updateSubmenuTabbability();
    } else {
        // Fallback to existing behavior if helper is not available
        $('.submenu-container a').attr('tabindex', '-1');
        $('.nav-item.dropdown.show .submenu-container a').removeAttr('tabindex');
    }
};

module.exports = function () {
    /**
    * Get the real vh values for lates ios and devices
    *
    * @returns {void} updates real vh values
    */
    function updateRealVH() {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--real-vh', `${vh}px`);
    }

    updateRealVH();
    window.addEventListener('resize', updateRealVH);

    var isDesktop = function (element) {
        return $(element).parents('.menu-toggleable-left').css('position') !== 'fixed';
    };

    var headerBannerStatus = window.sessionStorage.getItem('hide_header_banner');
    $('.header-banner .close').on('click', function () {
        $('.header-banner').not('.header-banner-ibc').addClass('d-none');
        window.sessionStorage.setItem('hide_header_banner', '1');
        var siteHeader = $('.site-header');
        if (siteHeader.length) {
            var headerHeight = siteHeader.outerHeight();
            $('body').css('--header-height', headerHeight + 'px');
            var mobileMenu = $('.navbar-toggler.icon-with-circle.menu-mobile-only');
            if (mobileMenu.length && mobileMenu.css('display') === 'none') {
                // if the mobile menu is not visible, it means it's desktop, so we need to update the top position of the submenu
                $('.submenu-outer.dropdown-menu.menu-level-1').css('top', headerHeight + 'px');
                $('.submenu-outer.dropdown-menu.menu-level-1').css('height', 'calc(100vh - ' + headerHeight + 'px)');
                $('.site-header .promotional-image').css('height', 'calc(100vh - ' + headerHeight + 'px)');
            }
        }
    });

    $('.navbar-header .logo-home').on('click', function () {
        sessionStorage.setItem('homeMenuClicked', 'true');
    });

    if (!headerBannerStatus || headerBannerStatus < 0) {
        $('.header-banner').removeClass('d-none');
    }

    /**
    * handleMenuContent - handles the menu content population for level 1 and level 2 menu items.
    * It checks if the content is already populated to avoid unnecessary DOM manipulation.
    * @param {*} $menuLink 'a' element
    */
    function handleMenuContent($menuLink) {
        var content = $menuLink.siblings('.promo-image-holder-level1').children().clone();
        var shopAllLevel1 = $menuLink.siblings('.shop-all-level-1').children().clone();
        var shopAllLevel2 = $menuLink.siblings('.shop-all-level-2').children().clone();
        var contentSubMenu = $menuLink.siblings('.promo-image-holder-level2').children().clone();
        var $menuLevel1 = $menuLink.siblings('.menu-level-1');
        var $contentLevel1 = $menuLevel1.children('.content-level-1');
        var $contentLevel2 = $menuLink.siblings('.menu-level-2').children('.content-level-2');

        applyContextualLabelsToFloatingLinks(content);
        applyContextualLabelsToFloatingLinks(contentSubMenu);

        if ($menuLink.hasClass('link-level-1')) {
            if (!$contentLevel1.children('.content-asset').length) {
                $contentLevel1.html('').append(content);
                if (!isDesktop($menuLink)) {
                    $contentLevel1.appendTo($menuLevel1);
                }

                applyContextualLabelsToFloatingLinks($contentLevel1);
                $menuLevel1.children('.left-content').children('.dropdown-container').children('.shop-all-cat-left').html('').append(shopAllLevel1);
            }

            $contentLevel1.removeClass('d-none');
        } else if ($menuLink.hasClass('link-level-2')) {
            if (!isDesktop($menuLink)) {
                $contentLevel2.html('').append(contentSubMenu);
                $menuLink.parent().find('.menu-level-2 .submenu-container.right-content.content-level-2').appendTo($menuLink.parent().find('.menu-level-2'));
                $('.menu-level-1 .submenu-container.right-content.content-level-1').addClass('d-none');
            } else {
                $contentLevel2.html('').append(contentSubMenu);
            }

            applyContextualLabelsToFloatingLinks($contentLevel2);
            $menuLink.parent().find('.menu-level-2').find('.shop-all-cat-left').html('').append(shopAllLevel2);
        }
        updateSubmenuTabbability();
    }

    /**
     * expandAndFocusFirstSubMenu
     * @param {*} $menuItem 'li' element of the menu
     * @param {*} $menuLink 'a' element of the menu
     */
    function expandAndFocusFirstSubMenu($menuItem, $menuLink) {
        $menuItem.addClass('show').children('.dropdown-menu').addClass('show');
        setDropdownLinkExpandedState($menuLink, true);
        focusFirstSubmenuItem($menuItem);
    }

    /**
     * Expands a dropdown from keyboard activation and guards against the
     * follow-up synthetic click that some assistive technologies dispatch.
     *
     * @param {JQuery<HTMLElement>} $menuItem - Dropdown list item.
     * @param {JQuery<HTMLElement>} $menuLink - Dropdown trigger element.
     * @param {Event} e - Keyboard event.
     * @returns {void}
     */
    function handleKeyboardDropdownActivation($menuItem, $menuLink, e) {
        e.preventDefault();
        expandAndFocusFirstSubMenu($menuItem, $menuLink);
        handleMenuContent($menuLink);
    }

    keyboardAccessibility(
        '.main-menu .nav-link, .main-menu .dropdown-link, .shop-all-cat-left a, .promotional-images-outer a, .floating-link a, .close-button button',
        {
            [constants.KEY_CODE_DOWN]: function (menuItem, e) {
                if (menuItem.hasClass('nav-item')) { // top level
                    $('.navbar-nav .show').removeClass('show')
                        .children('.dropdown-menu')
                        .removeClass('show');
                    menuItem.addClass('show').children('.dropdown-menu').addClass('show');
                    setDropdownLinkExpandedState($(this), true);
                    updateSubmenuTabbability();
                    menuItem.find('ul > li > a')
                        .first()
                        .focus();
                    e.preventDefault();
                } else if (moveFocusWithinActiveSubmenu(this, 1)) {
                    updateSubmenuTabbability();
                    e.preventDefault();
                }
            },
            [constants.KEY_CODE_RIGHT]: function (menuItem, e) {
                // If it's a dropdown item (top-level or nested), open the submenu
                if (menuItem.hasClass('dropdown')) {
                    expandAndFocusFirstSubMenu(menuItem, $(this));
                    handleMenuContent($(this));
                    e.preventDefault();
                } else if (menuItem.hasClass('nav-item')) {
                    // Top-level item without submenu: move to next menu item
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    setDropdownLinkExpandedState($(this), false);
                    updateSubmenuTabbability();
                    menuItem.next().children().first().focus();
                }
            },
            [constants.KEY_CODE_UP]: function (menuItem) {
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    setDropdownLinkExpandedState($(this), false);
                    updateSubmenuTabbability();
                } else if (moveFocusWithinActiveSubmenu(this, -1)) {
                    updateSubmenuTabbability();
                }
            },
            [constants.KEY_CODE_LEFT]: function (menuItem) {
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    setDropdownLinkExpandedState($(this), false);
                    updateSubmenuTabbability();
                    menuItem.prev().children().first().focus();
                } else {
                    var $focusElement = menuItem.closest('.show').removeClass('show')
                        .closest('li.show').removeClass('show')
                        .children()
                        .first();

                    $focusElement.focus();
                    setDropdownLinkExpandedState($focusElement, false);
                    updateSubmenuTabbability();
                }
            },
            [constants.KEY_CODE_ESC]: function (menuItem) {
                var parentMenu = menuItem.hasClass('show')
                    ? menuItem
                    : menuItem.closest('li.show');
                parentMenu.children('.show').removeClass('show');
                setDropdownLinkExpandedState(parentMenu.children().first(), false);
                parentMenu.removeClass('show');
                parentMenu.children().first().focus();
                updateSubmenuTabbability();
            },
            [constants.KEY_CODE_ENTER]: function (menuItem, e) {
                if (menuItem.hasClass('dropdown')) {
                    handleKeyboardDropdownActivation(menuItem, $(this), e);
                }
            },
            [constants.KEY_CODE_SPACE]: function (menuItem, e) {
                if (menuItem.hasClass('dropdown')) {
                    handleKeyboardDropdownActivation(menuItem, $(this), e);
                }
            }
        },
        function () {
            var $currentElement = $(this);

            if ($currentElement.is('.nav-link, .dropdown-link, .shop-all-cat-left a')) {
                return $currentElement.closest('li.nav-item, li.dropdown-item').first();
            }

            return $currentElement.parent();
        }
    );

    // Trap tab focus within open menu dropdowns - but only for items inside the submenu
    $(document).on('keydown', function (e) {
        if (e.key !== 'Tab' && e.keyCode !== constants.KEY_CODE_TAB) return;

        var $openDropdown = $('.nav-item.dropdown.show');
        if (!$openDropdown.length) return;

        // Only trap Tab if focus is actually inside the open submenu, not on the primary menu item itself
        var $focusedElement = $(document.activeElement);
        
        // Check if there's an open level-2 submenu
        var $openLevel2Submenu = $openDropdown.find('.dropdown-item.dropdown.show > .submenu-outer.dropdown-menu.show').first();
        
        // If a level-2 submenu is open, trap focus within it; otherwise use level-1
        var $activeTrapSubmenu = $openLevel2Submenu.length ? $openLevel2Submenu : $openDropdown.children('.submenu-outer.dropdown-menu.show');
        
        // If focus is not inside the active trap submenu, let natural Tab behavior happen
        if (!$activeTrapSubmenu.find($focusedElement).length) {
            return;
        }

        // Get all currently tabbable elements (those without tabindex="-1")
        // Only get focusable elements within the active trap submenu
        var focusableSelector = 'a[href]:not([tabindex="-1"]):visible, button:not([disabled]):not([tabindex="-1"]):visible, [tabindex="0"]:visible';
        var $focusableElements = $activeTrapSubmenu.find(focusableSelector).filter(function () {
            // If we're trapping in level-2, get all items directly in it
            if ($openLevel2Submenu.length) {
                return true;  // All focusable items in level-2 submenu
            }
            
            // If we're trapping in level-1, exclude items in collapsed level-2
            var $parentSubmenu = $(this).closest('.submenu-outer.dropdown-menu');
            // Only exclude if the parent submenu is NOT the current trap submenu AND it's not open
            if ($parentSubmenu.length && !$parentSubmenu.is($activeTrapSubmenu) && !$parentSubmenu.hasClass('show')) {
                return false;  // Exclude this element (it's in a collapsed level-2)
            }
            return true;
        });

        if (!$focusableElements.length) return;

        var $firstFocusable = $focusableElements.first();
        var $lastFocusable = $focusableElements.last();
        var currentIndex = $focusableElements.index($focusedElement);

        // Always prevent default and manually handle Tab to stay within filtered elements only
        e.preventDefault();

        if (e.shiftKey) {
            // Shift+Tab: move backward through elements
            if (currentIndex <= 0) {
                // If on first element or outside list, wrap to last
                $lastFocusable.focus();
            } else {
                // Move to previous focusable element
                $focusableElements.eq(currentIndex - 1).focus();
            }
        } else if (currentIndex >= $focusableElements.length - 1) {
            // Tab: if on last element, wrap to first
            $firstFocusable.focus();
        } else {
            // Tab: move to next focusable element
            $focusableElements.eq(currentIndex + 1).focus();
        }
    });

    // Fire GTM events on page load
    $(document).ready(function () {
        if (sessionStorage.getItem('homeMenuClicked') === 'true') {
            gtm.homeMenuNavigation();
            sessionStorage.removeItem('homeMenuClicked');
        }

        if (sessionStorage.getItem('loggedInSuccessful') === 'true') {
            gtm.userLogin();
            sessionStorage.removeItem('loggedInSuccessful');
        }
    });

    /**
    * Gets the height of the header as a pixel value string.
    *
    * @returns {void} The height in pixels (e.g., "120px")
    */
    function updateHeaderOffset() {
        var headerHeight = $('header').outerHeight();
        $(':root').css('--header-offset', headerHeight + 'px');
    }

    /**
    * Gets the height of the header without navigation as a pixel value string.
    *
    * @returns {void} The height in pixels (e.g., "120px")
    */
    function calcHeaderIgnoreNavOffset() {
        let $siteHeader = $('.site-header');
        let $navigation = $('.js-navigation');
        var headerIgnoreNav = $siteHeader.height() - $navigation.height();
        $(':root').css('--header-ignorenav-offset', headerIgnoreNav + 'px');
    }

    /**
     * assignMissingRolesToContentAssetLinks - Assigns role="menuitem" to all links
     * within content assets that are missing the role attribute.
     * This only applies to content assets within the main-menu to avoid affecting other areas.
     * This ensures proper accessibility setup during page load.
     *
     * @returns {void}
     */
    function assignMissingRolesToContentAssetLinks() {
        // Find all content assets within main-menu and their descendant links
        $('.main-menu').find('.content-asset').find('a').each(function () {
            var $link = $(this);
            if (!$link.attr('role')) {
                $link.attr('role', 'menuitem');
            }
        });
    }

    // Run on page load
    $(document).ready(function () {
        updateHeaderOffset();
        updateSubmenuTabbability();
        applyContextualLabelsToFloatingLinks($('.menu-group'));
        assignMissingRolesToContentAssetLinks();
    });

    // Run on window resize
    $(window).on('resize', function () {
        updateHeaderOffset();
    });

    // close the navigation menu if clicked outside
    $(document).on('click', function (event) {
        const isInsideDiv = $(event.target).closest('div.submenu-container').length;
        const isIgnoreButton = $(event.target).is('.dropdown:not(.disabled) [data-toggle="dropdown"]');
        const isInsideMenu = $('body').find('.main-menu.in').length;
        if (!isIgnoreButton && !isInsideDiv && !isInsideMenu) {
            $('.nav-item.dropdown').removeClass('show');
            $('div.dropdown-menu').removeClass('show');
            collapseExpandedMenuTriggers('.main-menu');
            $('body').removeClass('no-scroll');
            updateSubmenuTabbability();
        }
    });

    $('.dropdown:not(.disabled) [data-toggle="dropdown"]')
        .off('click')
        .on('click', function (e) {
            var $menuLink = $(this);
            var $menuItem = $menuLink.parent();

            if (!isDesktop(this)) {
                $('.modal-background').show();
                // copy parent element into current UL
                var link = $(this).clone().removeClass('dropdown-toggle')
                    .removeAttr('data-toggle')
                    .removeAttr('aria-expanded')
                    .attr('aria-haspopup', 'false');
                var topCategoryName = link.text();
                var closeMenu = $('<li class="nav-menu"></li>');
                closeMenu.append($('.close-menu').first().clone());
                closeMenu.find('.logo-shop-container').detach();
                closeMenu.find('.back button').contents().filter(function () {
                    return this.nodeType === 3;
                }).first().replaceWith(topCategoryName);
                $(this).parent().find('.submenu-outer.dropdown-menu').first().find('.submenu-container.left-content .dropdown-container').first()
                    .prepend(closeMenu)
                    .removeAttr('hidden');

                if (!$('body').hasClass('no-scroll')) {
                    $('body').addClass('no-scroll');
                }
                // copy navigation menu into view
                $(this).parent().addClass('show');
                $(this).siblings('.dropdown-menu').addClass('show');
                setDropdownLinkExpandedState($(this), true);
                $(link).focus();
                $('div.menu-group > ul.nav.navbar-nav > li.nav-item > a').attr('aria-hidden', 'true');
                e.preventDefault();
                handleMenuContent($(this));
                updateSubmenuTabbability();
            } else {
                e.preventDefault();
                var eventElement = this;
                if ($(this).parent().hasClass('show')) {
                    $(this).parent().removeClass('show');
                    $(this).parent().find('div.dropdown-menu').removeClass('show');
                    setDropdownLinkExpandedState($(this), false);
                    if ($(this).hasClass('link-level-1')) {
                        $('body').removeClass('no-scroll');
                    }
                } else {
                    $('.navbar-nav > li').each(function () {
                        if (!$.contains(this, eventElement)) {
                            $(this).find('.show').each(function () {
                                clearSelection(this);
                            });
                            if ($(this).hasClass('show')) {
                                $(this).removeClass('show');
                                $(this).children('div.dropdown-menu').removeClass('show');
                                setDropdownLinkExpandedState($(this).children().first(), false);
                            }
                        }
                    });

                    // Remove 'no-animation' class from all level 2 menu dropdowns
                    $('.menu-level-2').removeClass('no-animation');

                    // Add 'no-animation' class if any level 2 menu dropdown is currently open
                    if ($('.menu-level-2.show').length > 0) {
                        $('.menu-level-2').addClass('no-animation');
                    }
                    // need to close all the dropdowns that are not direct parent of current dropdown
                    $('.dropdown-item.show').removeClass('show');
                    $('.menu-level-2.show').removeClass('show');
                    $(this).parent().addClass('show');
                    $(this).siblings('.dropdown-menu').addClass('show');
                    setDropdownLinkExpandedState($(this), true);
                    focusFirstSubmenuItem($menuItem);
                    $('body').addClass('no-scroll');
                }
                handleMenuContent($(this));
                updateSubmenuTabbability();
            }
        });

    $('.navbar>.close-menu>.close-button').on('click', function (e) {
        e.preventDefault();
        collapseExpandedMenuTriggers('.main-menu');
        $('.navbar-nav').find('.show').removeClass('show');
        $('.navbar-nav').find('.top-category').detach();
        $('.navbar-nav').find('.nav-menu').detach();
        $('.menu-toggleable-left').removeClass('in');
        $('.modal-background').hide();

        $('.navbar-toggler').focus();

        $('.main-menu').attr('aria-hidden', 'true');
        $('.main-menu').siblings().attr('aria-hidden', 'false');
        $('header').siblings().attr('aria-hidden', 'false');
        $('body').removeClass('no-scroll');
        updateSubmenuTabbability();
    });

    $('.navbar-nav').on('click', '.back', function (e) {
        e.preventDefault();
        clearSelection(this);
    });

    $('.navbar-nav').on('click', '.close-button', function (e) {
        e.preventDefault();
        collapseExpandedMenuTriggers('.main-menu');
        $('.navbar-nav').find('.top-category').detach();
        $('.navbar-nav').find('.nav-menu').detach();
        $('.navbar-nav').find('.show').removeClass('show');
        $('.menu-toggleable-left').removeClass('in');
        $('body').removeClass('no-scroll');

        $('.main-menu').siblings().attr('aria-hidden', 'false');
        $('header').siblings().attr('aria-hidden', 'false');

        $('.modal-background').hide();
        $('body').removeClass('no-scroll');
        updateSubmenuTabbability();
    });

    $('body').on('click', '.close-menu-selector', function (e) {
        e.preventDefault();
        var $dropdown = $(this).parents('.mobile-menu-dropdown.dropdown');
        $dropdown.removeClass('show');
        setDropdownLinkExpandedState($dropdown.children().first(), false);
    });

    $('.navbar-toggler').click(function (e) {
        e.preventDefault();
        $('.main-menu').toggleClass('in');
        $('.modal-background').show();
        if (!$('body').hasClass('no-scroll')) {
            $('body').addClass('no-scroll');
        }
        $('.main-menu').removeClass('d-none');
        $('.main-menu').attr('aria-hidden', 'false');
        $('.main-menu').siblings().attr('aria-hidden', 'true');
        $('header').siblings().attr('aria-hidden', 'true');

        if ($('.header-banner').hasClass('warm-user')) {
            $('.menu.logo-home').addClass('d-none');
            $('.shop-outer').removeClass('d-none');
            var $mobileTrayWrapper = $('<div class="ibc-user default-tray"></div>');
            var $warmUserTrigger = $('.header-banner .warm-user-details').first().clone(true, true);
            var $warmUserTrayContent = $('.header-banner .ibc-user.default-tray .default-tray-content').first().clone(true, true);

            $warmUserTrigger.attr('aria-expanded', 'false');
            $mobileTrayWrapper.append($warmUserTrigger);

            if ($warmUserTrayContent.length) {
                $mobileTrayWrapper.append($warmUserTrayContent);
            }

            $('.shop-outer').html('').append($mobileTrayWrapper);
        } else {
            $('.menu.logo-home').removeClass('d-none');
            $('.shop-outer').addClass('d-none');
        }

        $('.main-menu .nav.navbar-nav .nav-link').first().focus();
    });

    /**
    * Adjusts account popover horizontal position to prevent viewport overflow.
    * Always calculates from initial left: 0 position to ensure consistent placement.
    * Accounts for vertical scrollbar width in viewport calculations.
    *
    * @param {JQuery<HTMLElement>} $user account container element
    */
    function adjustPopoverPosition($user) {
        var $popover = $user.find('.popover');
        var $popoverContent = $user.find('.popover-bottom');

        if (!$popover.length || !$popoverContent.length) {
            return;
        }

        // Use requestAnimationFrame to ensure DOM is ready
        requestAnimationFrame(function () {
            // Always reset to left: 0 first to get accurate measurements from baseline
            $popover.css('left', '0');

            var contentRect = $popoverContent[0].getBoundingClientRect();
            // Use clientWidth to account for scrollbar
            var viewportWidth = document.documentElement.clientWidth;
            var padding = 8; // Safety margin
            var overflow;
            var newLeft;

            // Check if popover overflows right edge (when starting from left: 0)
            if (contentRect.right > viewportWidth - padding) {
                // Shift left to keep within viewport, calculated from 0
                overflow = contentRect.right - (viewportWidth - padding);
                newLeft = 0 - overflow;
                $popover.css('left', newLeft + 'px');
            }
            // Check if popover overflows left edge
            else if (contentRect.left < padding) {
                // Shift right to keep within viewport, calculated from 0
                overflow = padding - contentRect.left;
                newLeft = 0 + overflow;
                $popover.css('left', newLeft + 'px');
            }
            // If no overflow, stay at left-aligned position
            else {
                $popover.css('left', '0');
            }
        });
    }

    /**
    * Syncs account dropdown visibility and ARIA state for trigger and menu.
    * Adjusts dropdown position to prevent viewport overflow.
    *
    * @param {JQuery<HTMLElement>} $user account container element
    * @param {boolean} isExpanded Whether the account popover is expanded.
    */
    function setHeaderAccountPopoverState($user, isExpanded) {
        if (!$user || !$user.length) {
            return;
        }

        var expandedState = isExpanded ? 'true' : 'false';

        $user.find('.popover').toggleClass('show', isExpanded);
        $user.find('#myaccount').attr('aria-expanded', expandedState);
        $user.find('#account-menu-popover').attr('aria-hidden', isExpanded ? 'false' : 'true');

        // Adjust dropdown position if it would overflow viewport
        if (isExpanded) {
            adjustPopoverPosition($user);
        }
    }

    keyboardAccessibility(
        '.navbar-header .user',
        {
            [constants.KEY_CODE_DOWN]: function (scope) {
                if (!scope || !scope.menuLinks.length) {
                    return;
                }

                var $focused = $(document.activeElement);
                if ($focused.is(scope.trigger)) {
                    setHeaderAccountPopoverState(scope.user, true);
                    scope.menuLinks.first().focus();
                    return;
                }

                var currentIndex = scope.menuLinks.index($focused);
                if (currentIndex === -1) {
                    return;
                }

                var nextIndex = Math.min(currentIndex + 1, scope.menuLinks.length - 1);
                scope.menuLinks.eq(nextIndex).focus();
            },
            [constants.KEY_CODE_UP]: function (scope) {
                if (!scope || !scope.menuLinks.length) {
                    return;
                }

                var $focused = $(document.activeElement);
                var currentIndex = scope.menuLinks.index($focused);

                if (currentIndex > 0) {
                    scope.menuLinks.eq(currentIndex - 1).focus();
                } else if (currentIndex === 0 || $focused.is(scope.trigger)) {
                    scope.trigger.focus();
                    setHeaderAccountPopoverState(scope.user, false);
                }
            },
            [constants.KEY_CODE_ESC]: function (scope) {
                if (!scope) {
                    return;
                }

                setHeaderAccountPopoverState(scope.user, false);
                scope.trigger.focus();
            },
            [constants.KEY_CODE_TAB]: function (scope) {
                if (!scope) {
                    return;
                }

                setHeaderAccountPopoverState(scope.user, false);
            }
        },
        function () {
            var $user = $(this);

            return {
                user: $user,
                trigger: $user.find('#myaccount'),
                popover: $user.find('.popover'),
                menuLinks: $user.find('.popover li.nav-item > a')
            };
        }
    );


    $('body').on('click', '.navbar-header .user #myaccount, .navbar-header .user .user-message', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var $user = $('.navbar-header .user');

        if ($user.find('.popover').length > 0) {
            var isExpanded = $user.find('#myaccount').attr('aria-expanded') === 'true';
            setHeaderAccountPopoverState($user, !isExpanded);
        }
    });

    $(document).on('click', function (event) {
        var $target = $(event.target);
        var $user = $('.navbar-header .user');
        var $popover = $('.navbar-header .user .popover');

        if (!$target.closest('.navbar-header .user').length && $popover.hasClass('show')) {
            setHeaderAccountPopoverState($user, false);
        }
    });

    $('.navbar-header .user').on('focusout', function () {
        var $user = $(this);

        window.setTimeout(function () {
            if (!$user.find(document.activeElement).length) {
                setHeaderAccountPopoverState($user, false);
            }
        }, 0);
    });
    $('body').on('header:updateHeaderOffset', function (e, ignoreNavigation) {
        updateHeaderOffset();

        if (ignoreNavigation) {
            calcHeaderIgnoreNavOffset();
        }
    });
    $('body').on('click', '.append-rurl-link', function (event) {
        var $link = $(this);
        var wl = window.location;
        var rurl = wl.pathname + wl.search + wl.hash;
        if (isRelativeUrl(rurl)) {
            var url = applyUrlParameter($link.attr('href'), 'rurl', rurl);
            if (url) {
                event.preventDefault();
                window.location.href = url;
            }
        }
    });
};
